import { axios } from "@/utils/request";

// 3011004 通过手机号获取下级用户信息
export function getUserInfoByTel(data) {
  return axios({
    url: '/h5UserSugar/getUserInfoByTel',
    method: 'post',
    data
  })
}


// 3011001 购物金转账
export function transferMoney(data) {
  return axios({
    url: '/h5UserSugar/transferMoney',
    method: 'post',
    data
  })
}

// 3011002 获取购物金
export function getUserSugarMoneyInfo(data) {
  return axios({
    url: '/h5UserSugar/getUserSugarMoneyInfo',
    method: 'post',
    data
  })
}


// 3011003 获取购物金列表
export function getUserSugarMoneyHistoryByPage(data) {
  return axios({
    url: '/h5UserSugar/getUserSugarMoneyHistoryByPage',
    method: 'post',
    data
  })
}
